import React from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import CurrentLocationControl from './components/CurrentLocationControl';
import SearchControl from './components/SearchControl';
import LocationInfoOverlay from './components/LocationInfoOverlay';
import MapComponent from './components/MapLayerComponent';
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import PropTypes from 'prop-types';

const defaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41]
});

const MapView = ({
  mode,
  userLocation,
  selectedLocation,
  setSelectedLocation,
  setAddressDetails,
  handleSearchSelect,
  isMapEditable,
  uploadedGeoJSONLayer,
  featureGroupRef,
  hasLayer,
  setHasLayer,
  setPolygonData,
  setAreaHectares,
  setAreaAcres,
  setPerimeter,
  areaAcres,
  areaHectares,
  perimeter
}) => {
  return (
    <MapContainer
      center={[userLocation.lat, userLocation.lng]}
      zoom={20}
      style={{ height: '70vh', width: '100%' }}
      zoomControl={false}
    >
      <TileLayer
        attribution="Google Maps"
        url="https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}"
        subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
      />

      {selectedLocation && (
        <Marker
          position={[selectedLocation.lat, selectedLocation.lng]}
          icon={defaultIcon}
        />
      )}

      {mode === 'location' && (
        <LocationInfoOverlay
          mode="location"
          location={selectedLocation}
          address={selectedLocation?.address}
        />
      )}

      {mode === 'polygon' && (
        <MapComponent
          uploadedGeoJSONLayer={uploadedGeoJSONLayer}
          isMapEditable={isMapEditable}
          featureGroupRef={featureGroupRef}
          hasLayer={hasLayer}
          setHasLayer={setHasLayer}
          setPolygonData={setPolygonData}
          setAreaHectares={setAreaHectares}
          setAreaAcres={setAreaAcres}
          setPerimeter={setPerimeter}
        />
      )}

      {mode === 'polygon' && (
        <LocationInfoOverlay
          mode="polygon"
          location={selectedLocation}
          areaHectares={areaHectares}
          areaAcres={areaAcres}
          perimeter={perimeter}
        />
      )}

      {isMapEditable && (
        <>
          <CurrentLocationControl onLocationFound={handleSearchSelect} />
          <SearchControl onLocationSelect={handleSearchSelect} />
        </>
      )}
    </MapContainer>
  );
};

MapView.defaultProps = {
  mode: 'location',
  userLocation: { lat: 0, lng: 0 },
  selectedLocation: null,
  setSelectedLocation: () => {},
  setAddressDetails: () => {},
  handleSearchSelect: () => {},
  isMapEditable: true,
  uploadedGeoJSONLayer: null,
  featureGroupRef: React.createRef(),
  hasLayer: false,
  setHasLayer: () => {},
  setPolygonData: () => {},
  setAreaHectares: () => {},
  setAreaAcres: () => {},
  setPerimeter: () => {},
  areaAcres: 0,
  areaHectares: 0,
  perimeter: 0
};
MapView.propTypes = {
  mode: PropTypes.oneOf(['location', 'polygon']),
  userLocation: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired
  }),
  selectedLocation: PropTypes.object,
  setSelectedLocation: PropTypes.func.isRequired,
  setAddressDetails: PropTypes.func.isRequired,
  handleSearchSelect: PropTypes.func.isRequired,
  isMapEditable: PropTypes.bool,
  uploadedGeoJSONLayer: PropTypes.object,
  featureGroupRef: PropTypes.object,
  hasLayer: PropTypes.bool,
  setHasLayer: PropTypes.func.isRequired,
  setPolygonData: PropTypes.func.isRequired,
  setAreaHectares: PropTypes.func.isRequired,
  setAreaAcres: PropTypes.func.isRequired,
  setPerimeter: PropTypes.func.isRequired,
  areaAcres: PropTypes.number,
  areaHectares: PropTypes.number,
  perimeter: PropTypes.number
};

export default MapView;
